"use client"
import { FooterColumnDto } from "api"
import styled from "styled-components"
import FooterItem, { FooterVariant } from "./FooterItem"

const Column = styled.div<{ $variant: FooterVariant }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(p) => (p.$variant === "desktop" ? "16px" : "20px")};
  ${(p) => p.theme.breakpoints.down("md")} {
    max-width: 148px;
  }
`

const Title = styled.h4<{ $variant: FooterVariant }>`
  margin: 0 0 ${(p) => (p.$variant === "desktop" ? "8px" : "3px")} 0;
  color: ${(p) => p.theme.colors.white};
  font-size: 20px;
  font-weight: 300;
  line-height: ${(p) => (p.$variant === "desktop" ? "32px" : "26px")};
  letter-spacing: 0.6px;
  white-space: nowrap;
`

type FooterColumnProps = {
  column: FooterColumnDto
  variant: FooterVariant
}

const FooterColumn = ({ column, variant }: FooterColumnProps) => {
  if (!column?.items?.length && !column?.title) return null

  // A column with any icon-bearing item is the "contact" column — its rendering
  // rules differ (see FooterItem). Derived from data, not a column type flag.
  const columnHasIcons = !!column.items?.some((item) => item.icon?.imageUrl)

  return (
    <Column $variant={variant}>
      {column.title && <Title $variant={variant}>{column.title}</Title>}
      {column.items?.map((item) => (
        <FooterItem
          key={item.id}
          item={item}
          variant={variant}
          columnHasIcons={columnHasIcons}
        />
      ))}
    </Column>
  )
}

export default FooterColumn
